import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { map, path } from 'ramda';
import { Container, Slider, OverflowWrapper, PaddingWrapper } from './swipableList.styles';
import { EntityRefData } from '../../../../shared/components/entityRefData';
import { ExperiencesListItem } from '../../experiencesListItem';
import { experiencePropType } from '../../../../propTypes';

export class SwipableList extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    experiences: PropTypes.arrayOf(experiencePropType),
    placeholder: PropTypes.bool,
  };

  placeholders = [{ id: 1, ratio: 1 }, { id: 2, ratio: 1.5 }, { id: 3, ratio: 1.25 }];

  renderItem = experience => {
    const heroImage = path(['heroGallery', 0], experience);

    return (
      <EntityRefData key={experience.id} id={heroImage}>
        {({ file } = {}) => (
          <PaddingWrapper>
            <ExperiencesListItem placeholder={this.props.placeholder} experience={experience} file={file} />
          </PaddingWrapper>
        )}
      </EntityRefData>
    );
  };

  render() {
    return (
      <OverflowWrapper>
        <Container className={this.props.className}>
          <Slider options={{ slidesToShow: 2 }}>
            {map(this.renderItem, this.props.placeholder ? this.placeholders : this.props.experiences)}
          </Slider>
        </Container>
      </OverflowWrapper>
    );
  }
}
